import {
  Dialog,
  DialogContent,
  DialogHeader,
  Modal,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useProfile } from "../../../../auth/ProfileProvider";
import { StripeSetupIntent } from "../../../../components/stripe/StripeSetupIntent";

interface AddPaymentProfileModalProps {
  handleClose: () => void;
  initialPaymentProfileCount: number;
}

export function AddPaymentProfileModal(props: AddPaymentProfileModalProps) {
  const { handleClose, initialPaymentProfileCount } = props;
  const { t } = useTranslation();
  const { profile } = useProfile();

  // Extract billing address (with fallback to personal address)
  const billingAddress = profile?.billing_address;
  const personalAddress = profile?.profileaddress_set?.[0];
  const defaultAddress = billingAddress
    ? {
        country: billingAddress.country,
        postal_code: billingAddress.postal_code,
      }
    : personalAddress
      ? {
          country: personalAddress.country,
          postal_code: personalAddress.postal_code,
        }
      : undefined;

  return (
    <Modal isOpen testID="add-payment-profile-modal">
      <Dialog width="456px">
        {() => (
          <>
            <DialogHeader onClose={handleClose}>
              {t("Add payment profile")}
            </DialogHeader>
            <DialogContent>
              <StripeSetupIntent
                handleClose={handleClose}
                initialPaymentProfileCount={initialPaymentProfileCount}
                defaultAddress={defaultAddress}
              />
            </DialogContent>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
